import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "assurance-api-reference"
    }}>{`Assurance API reference`}</h1>
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`Returns the current version of the AEP Assurance extension.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=extension-version"/>
     Flutter
     <Tabs query="platform=flutter&api=extension-version"/> -*/}
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <InlineAlert variant="warning" slots="header, text1" mdxType="InlineAlert" />
    <p>{`This API has been deprecated starting in v2.0.0 and removed in v3.0.0 of the Android mobile extension.`}</p>
    <p>{`Use `}<a parentName="p" {...{
        "href": "../mobile-core/api-reference.md#registerextensions"
      }}><inlineCode parentName="a">{`MobileCore.registerExtensions()`}</inlineCode></a>{` API instead.`}</p>
    <p>{`Registers the Assurance extension with the Mobile Core.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=register-extension" mdxType="Tabs" />
    <h2 {...{
      "id": "startsession"
    }}>{`startSession`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`startSession`}</inlineCode>{` API needs to be called to begin a AEP Assurance session. When called, the Mobile SDK displays a PIN authentication overlay to begin a session.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You may call this API when the app launches with a URL (see code snippet below for sample usage)`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=start-session" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=start-session" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=start-session"/>
     Flutter
     <Tabs query="platform=flutter&api=start-session"/> -*/}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      